var _rect, _rect2, _rect3, _circle, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhonedownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 2.66669,
    width: 20,
    height: 34.6667,
    rx: 3,
    fill: "#8CB9FD"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11.6665,
    y: 7.33344,
    width: 14.6667,
    height: 23.3333,
    rx: 2,
    fill: "#D8E5F3"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 13.667,
    y: 5,
    width: 10.6667,
    height: 1,
    fill: "#3182F6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.0003,
    cy: 34.3333,
    r: 1.33333,
    fill: "#3182F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.46 28.95C23.46 32.78 26.58 35.9 30.41 35.9L31.58 29.34L30.41 22C26.58 22 23.46 25.12 23.46 28.95Z",
    fill: "#3182F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 22V35.91C33.83 35.91 36.95 32.79 36.95 28.96C36.95 25.12 33.83 22 30 22Z",
    fill: "#3182F6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.25 26V31.5H30.21L30.69 28.43L30.21 26H29.25Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.17 26H30.21V31.5H31.17V26Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1997 33L27.1686 30L33.2308 30L30.1997 33Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhonedownload);
export default __webpack_public_path__ + "static/media/phonedownload.7c50485f39c7711af8648f5a36d1b7f3.svg";
export { ForwardRef as ReactComponent };